import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import { TimerActions } from './TimerActions';
import TimerStateHelper from './TimerStateHelper';
import { IGameState } from '../Game/IGameState';

export const TimerReducer: Reducer<IGameState> = (
    state: IGameState,
    action: ActionType<typeof TimerActions>
): IGameState => {
    switch (action.type) {
        case getType(TimerActions.updateTimer):
            state = TimerStateHelper.setTimer(
                state,
                action.payload.timer,
                action.payload.time !== null ? action.payload.time : null
            );
            break;
    }

    return state;
};
